import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import FindYourFit from "@/pages/FindYourFit";
import DropItem from "@/pages/DropItem";
import Checkout from "@/pages/Checkout";
import Success from "@/pages/Success";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/find-your-fit" element={<FindYourFit />} />
          <Route path="/drop/:id" element={<DropItem />} />
          <Route path="/checkout/:id" element={<Checkout />} />
          <Route path="/success/:orderId" element={<Success />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#050505",
            color: "#fafafa",
            border: "1px solid #333",
            borderRadius: 0,
            fontFamily: "JetBrains Mono, monospace",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            fontSize: "0.75rem",
          },
        }}
      />
    </div>
  );
}

export default App;
